module.exports = __webpack_public_path__ + "static/media/timer.0f5ec1d0.svg";